import React from 'react'

// Global dependencies
import { getMainTheme } from '../../core/utils/theme'
import { useMainContext } from '../../core/contexts/main'
import Text from '../../core/utils/Text'
import { useWindowSize } from '../../core/hooks/useWindowSize'
import { formatDate, formatNumber } from '../../core/utils/common'
import SpanLoading from '../../components/common/SpanLoading'
import { getNestedValue } from '../../components/layouts/Table/CustomTable'
import { useSessionsQuery } from '../../core/services/react-query/useAuthQuery'
const CardLayout = React.lazy(() => import('../../components/layouts/CardLayout'))

const DashboardPage = () => {
  return (
    <></>
  )
}

export default DashboardPage

export {
  getMainTheme,
  CardLayout,
  useMainContext,
  Text,
  useWindowSize,
  formatNumber,
  formatDate,
  SpanLoading,
  useSessionsQuery,
  getNestedValue,
}
